<form [formGroup]="checklistRowsForm" class="mc-spring-board" (keydown.enter)="$event.preventDefault()" (ngSubmit)="$event.preventDefault()">
  <div class="mc-spring-board-form-header mc-d-flex mc-project-checklist-rows-form-header-content">
    <ng-container *ngIf="checklistType === ProjectChecklistType.GenericList">
      <mat-form-field class="mc-form-field" mcColor="secondary">
        <mat-label>Add Row</mat-label>
        <input type="text" #rowInput formControlName="addRow" (keydown.enter)="onAddItem()" maxLength="250" matInput placeholder="Add Row">
        <mat-hint align="end">{{ rowInput.value.length }}/250</mat-hint>
      </mat-form-field>
      <button type="button" class="mc-project-checklist-rows-form-button" mat-icon-button matTooltip="Add a Row" (click)="onAddItem()">
        <mat-icon fontSet="project-titan" fontIcon="icon-add"></mat-icon>
      </button>
    </ng-container>

    <p *ngIf="checklistType === ProjectChecklistType.ProjectFiles">
      <mat-icon class="mc-yet-another-centered-text-icon text-x-large" color="info" fontSet="project-titan" fontIcon="icon-info"></mat-icon>
      Checklists use only the last committed files. Pending edits won't appear.
    </p>
  </div>

  <div #rowList class="mc-spring-board-form-body" [ngClass]="{'mc-project-checklist-rows-form-body-files': checklistType === ProjectChecklistType.ProjectFiles}">
    <div *ngIf="checklistType === ProjectChecklistType.GenericList" formArrayName="items">
      <div *ngFor="let item of items.controls">
        <div class="mc-d-flex mc-flex-row mc-project-checklist-rows-form-row">
          <mat-form-field class="mc-form-field" mcColor="secondary" [formGroup]="item">
            <mat-label>Row Name</mat-label>
            <input #row type="text" matInput formControlName="Name" maxLength="250" placeholder="Row Name">
            <mat-hint align="end">{{ row.value.length }}/250</mat-hint>
            <mat-error>
              <mc-form-control-error-message [form]="item" controlName="Name" type="mc_checklist_row_name"></mc-form-control-error-message>
            </mat-error>
          </mat-form-field>
          <button type="button" class="mc-project-checklist-rows-form-button" mat-icon-button matTooltip="Move Row Up" (click)="onMoveItem(item.value, true)">
            <mat-icon fontSet="project-titan" fontIcon="icon-collapse"></mat-icon>
          </button>
          <button type="button" class="mc-project-checklist-rows-form-button" mat-icon-button matTooltip="Move Row Down" (click)="onMoveItem(item.value, false)">
            <mat-icon fontSet="project-titan" fontIcon="icon-expand"></mat-icon>
          </button>
          <button type="button" class="mc-project-checklist-rows-form-button" mat-icon-button matTooltip="Remove Row" (click)="onRemoveItem(item.value)">
            <mat-icon fontSet="project-titan" fontIcon="icon-trash"></mat-icon>
          </button>
        </div>
        <mat-form-field class="mc-form-field mc-project-checklist-rows-form-note-field" mcColor="secondary" [formGroup]="item">
          <mat-label>Add Note (optional)</mat-label>
          <mat-hint align="end">{{ note.value.length }}/128</mat-hint>
          <input #note type="text" matInput formControlName="Note" placeholder="Add Note (optional)" maxLength="128">
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="checklistType === ProjectChecklistType.ProjectFiles" class="mc-form-field mc-project-checklist-rows-form-files-form-field">
      <mc-project-files-tree [treeData]="{projectId, branchName}" formControlName="addPaths" projectFilesTreeType="selection" (pathFiltersChanged)="onPathFilterChanged($event)" #projectFileSelect></mc-project-files-tree>
      <mat-error *ngIf="checklistRowsForm.get('addPaths').invalid" class="mc-form-field-subscript">
        <mc-form-control-error-message [form]="checklistRowsForm" controlName="addPaths" type="mc_files"></mc-form-control-error-message>
      </mat-error>
    </div>
  </div>

  <div *ngIf="showFormFooter" class="mc-spring-board-form-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>
    <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"> </mc-loader>
    <div class="mc-form-buttons">
      <button type="button" mat-stroked-button (click)="onCancelClicked()">Cancel</button>
      <button type="submit" mat-raised-button (click)="onSubmit()" color="primary" [disabled]="!dirty">Save</button>
    </div>
  </div>
</form>